var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "30px",
    viewBox: "0 0 28 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8EFDCFBD-4964-4A3D-8776-C41E5096D009") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Consultant",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paysheet",
    transform: "translate(-1502.000000, -43.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F8F8FA",
    x: 0,
    y: 0,
    width: 1680,
    height: 1182
  }), /*#__PURE__*/React.createElement("g", {
    id: "Top-Nav"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1680,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    fill: "#F8F8FA",
    x: 1462,
    y: 0,
    width: 108,
    height: 112
  }), /*#__PURE__*/React.createElement("g", {
    id: "notification",
    transform: "translate(1502.540312, 43.000000)",
    fill: "#292929"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.43149801,26 L17.4076583,26 L17.4076583,30 L9.43149801,30 L9.43149801,26 Z M13.4195781,0 C9.17004699,0 6.09765876,1.95534618 4.61728062,5.48670224 L4.51860612,5.7286718 C3.71938501,7.74525144 3.4917516,9.7855003 3.4552589,13.3123013 L3.45236888,13.592 L0.983151839,16.6888723 C0.34672706,17.486781 0,18.4781783 0,19.5 C0,21.9852814 2.00871483,24 4.48659014,24 L22.3525661,24 C23.3713429,24 24.3597858,23.6522366 25.1553168,23.0139096 L25.3267436,22.8693056 C27.1075155,21.2905598 27.3570143,18.5707425 25.8560044,16.6888723 L23.3857904,13.592 L23.3839034,13.3159993 C23.345945,9.64442825 23.1012548,7.58441002 22.2218756,5.48670224 C20.7414975,1.95534618 17.6691093,0 13.4195781,0 Z M13.4195781,4 C19.1256005,4 19.3889553,8.69991943 19.4011102,14.1968955 L19.4016983,15 L22.741837,19.1876525 C22.9138278,19.4032834 22.8789713,19.7179296 22.6639829,19.8904344 C22.5755905,19.9613596 22.4657635,20 22.3525661,20 L4.48659014,20 C4.21127066,20 3.98808013,19.7761424 3.98808013,19.5 C3.98808013,19.3864643 4.02660536,19.276309 4.09731922,19.1876525 L7.43745794,15 L7.44216304,13.404988 C7.48842986,8.25609249 7.98965365,4 13.4195781,4 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBlack);
export default __webpack_public_path__ + "static/media/notification-black.ebce348c73f43a306e60855c8401387e.svg";
export { ForwardRef as ReactComponent };